import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  return <div className="flex flex-col min-h-screen" data-id="element-96">
      <Header data-id="element-97" />
      <main className="flex-grow" data-id="element-98">{children}</main>
      <Footer data-id="element-99" />
    </div>;
};